/** @format */
import { CustomDropDown } from 'src/components/CustomDropDown/CustomDropDown';
import { DeleteIcon, DuplicateIcon, EditIcon, HideIcon, ThreedotsIcon, ViewIcon } from 'src/components/icons';
import { useTranslation } from 'react-i18next';

export default function ExtranetContentAdminItem({
  row,
  isActionsOpen,
  onActionsOpenChange,
  onEdit,
  onDuplicate,
  onToggleVisibility,
  onView,
  onRemove,
  isDuplicatePending = false,
  isVisibilityPending = false
}) {
  const { t } = useTranslation();
  return (
    <div
      className={`administration-extranet-contents-page__data-row${
        isActionsOpen ? ' administration-extranet-contents-page__data-row--actions-open' : ''
      }${row.published === false ? ' administration-extranet-contents-page__data-row--unpublished' : ''}`}
      role="row">
      <div
        className="administration-extranet-contents-page__cell administration-extranet-contents-page__cell--title"
        role="cell">
        <div className="administration-extranet-contents-page__title-wrap">
          <div className="administration-extranet-contents-page__title">{row.title}</div>
        </div>
      </div>
      <div className="administration-extranet-contents-page__cell cell--released" role="cell">
        {row.released}
      </div>
      <div className="administration-extranet-contents-page__cell cell--created" role="cell">
        {row.created}
      </div>
      <div className="administration-extranet-contents-page__cell cell--removed" role="cell">
        {row.removed}
      </div>
      <div className="administration-extranet-contents-page__cell cell--languages" role="cell">
        {row.languages}
      </div>
      <div className="administration-extranet-contents-page__cell cell--clicks" role="cell">
        {row.clicks}
      </div>
      <div
        className="administration-extranet-contents-page__cell administration-extranet-contents-page__cell--actions"
        role="cell">
        <CustomDropDown
          placement="bottomRight"
          overlayClassName="administration-extranet-contents-page__actions-dropdown"
          open={isActionsOpen}
          onOpenChange={onActionsOpenChange}
          trigger={
            <button
              type="button"
              className="administration-extranet-contents-page__icon-btn"
              aria-label={t('administrationPage.extranetContents.actionsAria')}
              aria-haspopup="menu">
              <ThreedotsIcon />
            </button>
          }>
          <ul className="custom-dropdown__menu" role="menu">
            <li className="custom-dropdown__menu-item" role="none">
              <button type="button" role="menuitem" onClick={() => onEdit(row.id)}>
                <span className="dropdown-item-with-icon">
                  <EditIcon width={20} height={20} />
                  {t('common.button.edit')}
                </span>
              </button>
            </li>
            <li className="custom-dropdown__menu-item" role="none">
              <button
                type="button"
                role="menuitem"
                disabled={isDuplicatePending}
                onClick={() => onDuplicate(row.id)}>
                <span className="dropdown-item-with-icon">
                  <DuplicateIcon width={20} height={20} />
                  {t('administrationPage.extranetContents.actions.duplicate')}
                </span>
              </button>
            </li>
            <li className="custom-dropdown__menu-item" role="none">
              <button
                type="button"
                role="menuitem"
                disabled={isVisibilityPending}
                onClick={() => onToggleVisibility(row.id)}>
                <span className="dropdown-item-with-icon">
                  {row.published === false ? (
                    <>
                      <ViewIcon width={20} height={20} />
                      {t('administrationPage.extranetContents.actions.show')}
                    </>
                  ) : (
                    <>
                      <HideIcon width={20} height={20} />
                      {t('administrationPage.extranetContents.actions.hide')}
                    </>
                  )}
                </span>
              </button>
            </li>
            <li className="custom-dropdown__menu-item" role="none">
              <button type="button" role="menuitem" onClick={() => onView(row.id)}>
                <span className="dropdown-item-with-icon">
                  <ViewIcon width={20} height={20} />
                  {t('common.button.view')}
                </span>
              </button>
            </li>
            <li className="custom-dropdown__menu-item" role="none">
              <button type="button" role="menuitem" onClick={() => onRemove(row.id)}>
                <span className="dropdown-item-with-icon">
                  <DeleteIcon width={20} height={20} />
                  {t('common.button.remove')}
                </span>
              </button>
            </li>
          </ul>
        </CustomDropDown>
      </div>
    </div>
  );
}
